import { convertTagToMark, convertTagToBlock, convertTagToHyperlink, convertTextNodeToText, convertTagToChildren, } from "./converters";
import { parseHtml } from "./parseHtml";
import { createDocumentNode, getAsList } from "./utils";
const DEFAULT_TAG_CONVERTERS = {
    h1: convertTagToBlock,
    h2: convertTagToBlock,
    h3: convertTagToBlock,
    h4: convertTagToBlock,
    h5: convertTagToBlock,
    h6: convertTagToBlock,
    hr: convertTagToBlock,
    li: convertTagToBlock,
    ol: convertTagToBlock,
    p: convertTagToBlock,
    blockquote: convertTagToBlock,
    table: convertTagToBlock,
    td: convertTagToBlock,
    th: convertTagToBlock,
    tr: convertTagToBlock,
    ul: convertTagToBlock,
    b: convertTagToMark,
    strong: convertTagToMark,
    pre: convertTagToMark,
    i: convertTagToMark,
    sub: convertTagToMark,
    sup: convertTagToMark,
    u: convertTagToMark,
    a: convertTagToHyperlink,
};
const mapHtmlNodeToRichTextNode = (node, marks, options) => {
    var _a;
    const { convertText, convertTag } = options;
    if (node.type === "text") {
        return convertText(node, marks);
    }
    const mapChildren = (node, mark) => {
        const newMarks = mark ? getAsList(mark) : [];
        const allMarks = newMarks.concat(marks);
        if (node.type === "element") {
            return node.children.flatMap((child) => mapHtmlNodeToRichTextNode(child, allMarks, options));
        }
        return getAsList(mapHtmlNodeToRichTextNode(node, allMarks, options));
    };
    const next = (node, marks) => {
        return mapChildren(node, marks);
    };
    const tagConverter = (_a = convertTag === null || convertTag === void 0 ? void 0 : convertTag[node.tagName]) !== null && _a !== void 0 ? _a : convertTagToChildren;
    const convertedNode = tagConverter(node, next);
    return convertedNode;
};
export const htmlStringToDocument = (htmlString, options = {}) => {
    var _a;
    const optionsWithDefaults = {
        convertTag: Object.assign(Object.assign({}, DEFAULT_TAG_CONVERTERS), options.convertTag),
        convertText: (_a = options.convertText) !== null && _a !== void 0 ? _a : convertTextNodeToText,
    };
    const parsedHtml = parseHtml(htmlString);
    const richTextNodes = parsedHtml.flatMap((node) => mapHtmlNodeToRichTextNode(node, [], optionsWithDefaults));
    return createDocumentNode(richTextNodes);
};
//# sourceMappingURL=htmlStringToDocument.js.map